import React, { FunctionComponent, useMemo, useState } from 'react'

import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import { Person } from '../../App/store/features/person/IPerson'
import { useKeyPress } from '../../Common/Hooks/useKeyPress'
import {
  calendarOpenFormDetailsSelector,
  setOpenEventDetails,
} from '../store/calendarSlice'
import { TOpenEventDetails } from '../types'

import { CrudPanelNavigation } from './CrudPanelNavigation'
import { FormSwitch } from './FormSwitch'
import {
  PanelContent,
  PanelContentWrapper,
  PanelWrapper,
  Backdrop,
} from './style'

export interface IProps {
  personList: Person[]
  openEventDetails: TOpenEventDetails
}

export const CrudPanel: FunctionComponent<IProps> = ({
  personList,
  openEventDetails,
}) => {
  const [isPanelFocus, setIsPanelFocus] = useState<boolean>(true)
  const calendarFormDetails = useAppSelector(calendarOpenFormDetailsSelector)
  const dispatch = useAppDispatch()

  const nonePanelActions: TOpenEventDetails['type'][] = ['cut', 'copy']
  const isPanelObsolete = nonePanelActions.includes(calendarFormDetails.type)

  const isEscPress: boolean = useKeyPress('Escape')

  useMemo(() => {
    if (!isEscPress) {
      return
    }
    if (!isPanelFocus) {
      return
    }
    dispatch(
      setOpenEventDetails({ openFormDetails: { type: 'idle', event: null } }),
    )
  }, [dispatch, isEscPress, isPanelFocus])

  if (isPanelObsolete) {
    return null
  }

  const isPanelOpen: boolean = openEventDetails.type !== 'idle'

  const backDropClickHandler = (): void => {
    dispatch(
      setOpenEventDetails({ openFormDetails: { type: 'idle', event: null } }),
    )
  }

  // TODO toggle html overflow when open -> probably with <Global/> style component
  return (
    <>
      <Backdrop isOpen={isPanelOpen} onClick={backDropClickHandler} />
      <PanelWrapper onClick={e => e.stopPropagation()} isOpen={isPanelOpen}>
        <CrudPanelNavigation
          openEventDetails={openEventDetails}
          personList={personList}
        />
        <PanelContentWrapper>
          <PanelContent>
            <FormSwitch
              personList={personList}
              eventDetails={openEventDetails}
              setIsPanelFocus={setIsPanelFocus}
            />
          </PanelContent>
        </PanelContentWrapper>
      </PanelWrapper>
    </>
  )
}
